var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2167AE",
    d: "M8.5 3.5V4h4a.5.5 0 0 1 0 1h-.59a12.6 12.6 0 0 1-3.47 6.32q.46.32.97.58l2.31 1.15a.5.5 0 1 1-.44.9l-2.32-1.16a10 10 0 0 1-1.28-.78q-.82.69-1.76 1.24l-1.17.68a.5.5 0 0 1-.5-.86l1.17-.69q.78-.45 1.46-1a9.5 9.5 0 0 1-2.87-4.76.5.5 0 1 1 .98-.24 8.5 8.5 0 0 0 2.65 4.33A11.6 11.6 0 0 0 10.89 5H3.5a.5.5 0 0 1 0-1h4v-.5a.5.5 0 0 1 1 0m8.56 6.09a.6.6 0 0 0-1.12 0l-3.91 10.74a.5.5 0 0 0 .94.34l.97-2.67h5.12l.97 2.67a.5.5 0 0 0 .94-.34zM18.7 17h-4.4l2.2-6.04z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/Translate.3b11f18787df4c3c8b8e18d29e4893d7.svg";
export { ForwardRef as ReactComponent };